module.exports = __webpack_public_path__ + "static/media/it_moneyrain.0a38e24c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/it_moneyrain.png
// module id = 1370
// module chunks = 1